module.exports = __webpack_public_path__ + "img/healthcheck-head@2x.d6177468.png";